import { Box, CircularProgress, Typography } from "@mui/material";

const ProgressView = () => {
    return (
        <Box sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            px: 10,
            py: 3,
            gap: 1,
        }}>
            <Typography>Please wait</Typography>
            <CircularProgress color="primary"/>
        </Box>

    );
};

export default ProgressView;